// extracted by mini-css-extract-plugin
export default {"row":"User_row__RqUHK","answer":"User_answer__Iu79K","button":"User_button__htMVC","textbox":"User_textbox__r9Mfm"};